import { IPortalAssets } from './IPortalAssets.js';
/* [AddAsset: import] */

export const portalAssets: IPortalAssets = {
	/* [InitComponentAsset: assetKey] */
};
